import PropTypes from 'prop-types';
import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';

import { formatDate } from '../utils/dateUtils';
import { HomeCheckerShape } from '../../shapes/HomeChecker';
import CheckedIconPhoto from '../ListingLabel/checkedInfo/ChekedIconPhoto';

import styles from './VerificationInfo.module.scss';

const VERIFICATION_DATE_FORMAT = 'dd MMM yyyy';

const VerificationInfo = ({
  className = '',
  homechecker = null,
  verificationDate = null
}) => {
  const { photoUrl, firstName } = homechecker || {};

  return (
    <div className={classNames(styles['homechecker-info'], className)}>
      <div className={styles['homechecker-info__image']}>
        <CheckedIconPhoto isVerified photoUrl={photoUrl} />
      </div>
      <div className={styles['homechecker-info__content']}>
        <p
          data-test="homechecker-info-name"
          className={styles['homechecker-info__name']}
        >
          {firstName
            ? trans('HomeCheckerBox.verified.homechecker', { firstName })
            : trans('listing.verification.virtual')}
        </p>
        {verificationDate && (
          <p
            data-test="homechecker-info-date"
            className={styles['homechecker-info__date']}
          >
            {trans('on.date', {
              date: formatDate(verificationDate, VERIFICATION_DATE_FORMAT)
            })}
          </p>
        )}
      </div>
    </div>
  );
};

VerificationInfo.propTypes = {
  className: PropTypes.string,
  homechecker: PropTypes.shape(HomeCheckerShape),
  verificationDate: PropTypes.string
};

export default VerificationInfo;
